import React from "react"
import { Container } from "reactstrap"

const PRIVACY_POLICY_URL = "https://amok.earth/privacy-policy/"
const TERMS_URL = "https://amok.earth/terms-conditions/"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <div className="footer-content">
            <div className="footer-copyright">
              © Amok Earth {new Date().getFullYear()}. All Rights Reserved.
            </div>
            <div className="footer-links">
              <a
                href={PRIVACY_POLICY_URL}
                className="footer-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              <span className="footer-link-separator">|</span>
              <a
                href={TERMS_URL}
                className="footer-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms &amp; Conditions
              </a>
            </div>
          </div>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
